/* RealityLink Arena — product card: variant/option switching + add to cart (uses RL.cart). */
(function () {
  var RL = (window.RL = window.RL || {});

  document.querySelectorAll('[data-product-card]').forEach(function (card) {
    var opts = card.querySelectorAll('[data-opt]');
    var priceEl = card.querySelector('[data-price].prod-price') || card.querySelector('.prod-price[data-price]') || card.querySelector('[data-price]');
    var gc = card.querySelector('[data-gc-amt]');
    var addBtn = card.querySelector('[data-add]');

    opts.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        opts.forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
        if (priceEl) priceEl.textContent = btn.getAttribute('data-price');
        if (gc) gc.textContent = btn.getAttribute('data-amt');
        if (addBtn) addBtn.setAttribute('data-variant-id', btn.getAttribute('data-variant-id'));
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var id = addBtn.getAttribute('data-variant-id');
        if (!id || addBtn.disabled) return;
        if (!RL.cart) { window.location.href = '/cart'; return; }
        RL.cart.add(id, 1).then(function () {
          var name = (card.querySelector('h3') || {}).textContent || 'ITEM';
          addBtn.textContent = 'Added ✓';
          addBtn.classList.add('added');
          if (RL.toast) RL.toast('ADDED TO CACHE // ' + name.trim().toUpperCase());
          setTimeout(function () { addBtn.textContent = 'Add to Cart'; addBtn.classList.remove('added'); }, 1400);
        });
      });
    }
  });

  if (RL.reveals) RL.reveals();
})();
